import { render, staticRenderFns } from "./SMSTemplateEditor.vue?vue&type=template&id=f4f6eb76&scoped=true"
import script from "./SMSTemplateEditor.vue?vue&type=script&lang=js"
export * from "./SMSTemplateEditor.vue?vue&type=script&lang=js"
import style0 from "./SMSTemplateEditor.vue?vue&type=style&index=0&id=f4f6eb76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f6eb76",
  null
  
)

export default component.exports